export const test: string = 'test';

export { GetSDK } from './Sdk';
export { Frame } from './components/Frame';
export * from './SceneComponent';

// vs-app only
export * from './sdk-components/CanvasRenderer';
export * from './sdk-components/OrientedBox';
export * from './sdk-components/SecurityCamera';
export * from './sdk-components/SceneRenderer';
export * from './sdk-components/Slot';
export * from './sdk-components/PlaneRenderer';
export * from './sdk-components/VideoRenderer';
export * from './sdk-components/VideoStreamCapture';
export * from './sdk-components/NestThermostat';
export * from './sdk-components/RoomShadow';
export * from './sdk-components/ClockPainter';
export * from './sdk-components/SphereSource';
// 2026.02.11 : 박은정 : QuadImagePlane 컴포넌트 export (4개 꼭짓점 좌표 기반 이미지 배치)
export * from './sdk-components/QuadImagePlane';
// 2026.02.12 : 박은정 : QuadTextPlane 컴포넌트 export (4개 꼭짓점 좌표 기반 텍스트 배치)
export * from './sdk-components/QuadTextPlane';

// vs-app only
import { orientedBoxType, makeOrientedBox } from './sdk-components/OrientedBox';
import { slotType, makeSlot } from './sdk-components/Slot';
import { securityCameraType, makeSecurityCamera } from './sdk-components/SecurityCamera';
import { loadingIndicatorType, makeLoadingIndicator } from './sdk-components/LoadingIndicator';
import { planeRendererType, makePlaneRenderer } from './sdk-components/PlaneRenderer';
import { canvasRendererType, makeCanvasRenderer } from './sdk-components/CanvasRenderer';
import { sceneRendererType, makeSceneRenderer } from './sdk-components/SceneRenderer';
import { videoRendererType, makeVideoRenderer } from './sdk-components/VideoRenderer';
import { videoStreamCaptureType, makeVideoStreamCapture } from './sdk-components/VideoStreamCapture';
import { nestThermostatType, makeNestThermostat } from './sdk-components/NestThermostat';
import { roomShadowType, makeRoomShadow } from './sdk-components/RoomShadow';
import { clockPainterType, makeClockPainter } from './sdk-components/ClockPainter';
import { scenePainterType, makeScenePainter } from './sdk-components/ScenePainter';
import { tunerType, makeTuner } from './sdk-components/Tuner';
import { hlsLoaderType, makeHlsLoader } from './sdk-components/HlsLoader';
import { mjpegPlayerType, makeMjpegPlayer } from './sdk-components/MjpegPlayer';
import { toggleStateType, makeToggleState } from './sdk-components/ToggleState';
import { canvasBorderType, makeCanvasBorder } from './sdk-components/CanvasBorder';
import { canvasTextType, makeCanvasText } from './sdk-components/CanvasText';
import { canvasImageType, makeCanvasImage } from './sdk-components/CanvasImage';
// 2026.02.11 : 박은정 : QuadImagePlane 컴포넌트 import (4개 꼭짓점 좌표 기반 이미지 배치)
import { quadImagePlaneType, makeQuadImagePlane } from './sdk-components/QuadImagePlane';
// 2026.02.12 : 박은정 : QuadTextPlane 컴포넌트 import (4개 꼭짓점 좌표 기반 텍스트 배치)
import { quadTextPlaneType, makeQuadTextPlane } from './sdk-components/QuadTextPlane';
import { cameraInputType, makeCameraInput } from './sdk-components/Camera';

// vs-app + inspector
import { makeSphereSource, sphereSourceType } from './sdk-components/SphereSource';
import { boxSourceType, makeBoxSource } from './sdk-components/BoxSource';
import { cylinderSourceType, makeCylinderSource } from './sdk-components/CylinderSource';

// TO-DO - Used in vs-app and inspector - might de-globalize
export const initComponents = async (sdk: any) => {
  await Promise.all([
    sdk.Scene.register(orientedBoxType, makeOrientedBox),
    sdk.Scene.register(slotType, makeSlot),
    sdk.Scene.register(securityCameraType, makeSecurityCamera),
    sdk.Scene.register(loadingIndicatorType, makeLoadingIndicator),
    sdk.Scene.register(planeRendererType, makePlaneRenderer),
    sdk.Scene.register(canvasRendererType, makeCanvasRenderer),
    sdk.Scene.register(sceneRendererType, makeSceneRenderer),
    sdk.Scene.register(videoRendererType, makeVideoRenderer),
    sdk.Scene.register(videoStreamCaptureType, makeVideoStreamCapture),
    sdk.Scene.register(nestThermostatType, makeNestThermostat),
    sdk.Scene.register(roomShadowType, makeRoomShadow),
    sdk.Scene.register(clockPainterType, makeClockPainter),
    sdk.Scene.register(scenePainterType, makeScenePainter),
    sdk.Scene.register(tunerType, makeTuner),
    sdk.Scene.register(hlsLoaderType, makeHlsLoader),
    sdk.Scene.register(mjpegPlayerType, makeMjpegPlayer),
    sdk.Scene.register(toggleStateType, makeToggleState),
    sdk.Scene.register(canvasBorderType, makeCanvasBorder),
    sdk.Scene.register(canvasTextType, makeCanvasText),
    sdk.Scene.register(canvasImageType, makeCanvasImage),
    // 2026.02.11 : 박은정 : QuadImagePlane 컴포넌트 등록
    sdk.Scene.register(quadImagePlaneType, makeQuadImagePlane),
    // 2026.02.12 : 박은정 : QuadTextPlane 컴포넌트 등록
    sdk.Scene.register(quadTextPlaneType, makeQuadTextPlane),
    sdk.Scene.register(cameraInputType, makeCameraInput),
    sdk.Scene.register(sphereSourceType, makeSphereSource(sdk)),
    sdk.Scene.register(boxSourceType, makeBoxSource(sdk)),
    sdk.Scene.register(cylinderSourceType, makeCylinderSource(sdk)),
  ]);
};

export const assetVersion = '1.0-2-g6b74572';
export const cdnUrl = `https://static.matterport.com/showcase-sdk/examples/assets-${assetVersion}/assets`;
// 2026-04-29 보안 감사 : sdkKey 환경 변수 주입(webpack.DefinePlugin)으로 전환.
//   - 운영 빌드: systemd EnvironmentFile 등에서 MP_SDK_KEY 주입 → DefinePlugin 이 빌드 시점에 'process.env.MP_SDK_KEY' 를 리터럴로 치환.
//   - 미주입 환경: 빈 문자열 + console.warn → SDK 초기화 단계에서 명시적 실패하여 키 누락이 조용히 넘어가지 않도록 함.
//   - 폐기 키 4종(이전에 주석으로 누적되어 있던 값)은 본 커밋에서 제거. git history 에는 잔존하므로 별도 회수(BFG/git filter-repo) 필요.
//   - 자세한 적용 절차 및 잔여 작업: security-check/secrets_exposure.md 참고.
//
// 2026-04-29 후속 fix : 이전 버전의 가드 `typeof process !== 'undefined' && process.env && process.env.MP_SDK_KEY`
// 는 브라우저 런타임에서 `typeof process === 'undefined'` 이므로 항상 false 로 단락되어
// DefinePlugin 으로 치환된 리터럴까지 무력화시켰음. webpack DefinePlugin 은 `process.env.MP_SDK_KEY` 토큰을
// 빌드타임에 리터럴 문자열로 치환하므로, 런타임 process 객체에 의존하지 않음.
// 다만 DefinePlugin 미적용 환경(테스트, 비-webpack 빌드)에서 ReferenceError 를 던지지 않도록 try/catch 로 감쌈.
declare const process: { env: { MP_SDK_KEY?: string } };
let injectedKey = '';
try {
  // @ts-ignore - DefinePlugin 으로 빌드타임 치환되는 토큰. 미치환 환경에서는 ReferenceError → catch.
  injectedKey = process.env.MP_SDK_KEY || '';
} catch {
  injectedKey = '';
}
export const sdkKey: string = injectedKey;
if (!sdkKey && typeof console !== 'undefined') {
  console.warn(
    '[@mp/common] MP_SDK_KEY 가 주입되지 않았습니다. ' +
    'webpack.DefinePlugin({"process.env.MP_SDK_KEY": JSON.stringify(process.env.MP_SDK_KEY)}) 설정이 필요합니다.'
  );
}
export const interfaceVersion = '3.10';
